import React, { createContext, useContext } from "react";
import { ConditionBuilderContextValue } from "@/components/ConditionBuilder/types";

const ConditionBuilderContext = createContext<
  ConditionBuilderContextValue | undefined
>(undefined);

export const ConditionBuilderProvider: React.FC<{
  value: ConditionBuilderContextValue;
  children: React.ReactNode;
}> = ({ value, children }) => {
  return (
    <ConditionBuilderContext.Provider value={value}>
      {children}
    </ConditionBuilderContext.Provider>
  );
};

export const useConditionBuilderContext = (): ConditionBuilderContextValue => {
  const context = useContext(ConditionBuilderContext);
  if (context === undefined) {
    throw new Error(
      "useConditionBuilderContext must be used within a ConditionBuilderProvider",
    );
  }
  return context;
};
